import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ContentBlock } from '../../models';

@Component({
  selector: 'app-content-block-instagram-feed',
  templateUrl: './content-block-instagram-feed.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlockInstagramFeedComponent {
  @Input() block!: ContentBlock;

  constructor() {}
}
